import PropTypes from "prop-types";
import styles from "./AddressInfo.module.css";

/**
 * View component,  information for an address.
 */
export function AddressInfo({ addressInfo }) {
  const recipientName = addressInfo?.recipientName || addressInfo?.recipient;

  return (
    <div className={styles.container}>
      {addressInfo?.nickname && (
        <>
          <span className={styles.nickname}>{addressInfo.nickname}</span>
          <br />
        </>
      )}
      {recipientName && (
        <>
          <span className={styles.recipient}>{recipientName}</span>
          <br />
        </>
      )}
      <span>{addressInfo.address1}</span>
      <br />
      {addressInfo.address2 && (
        <>
          <span>{addressInfo.address2}</span>
          <br />
        </>
      )}
      <span>
        {[`${addressInfo.city},`, addressInfo.state, addressInfo.zip]
          .filter(Boolean)
          .join(" ")}
      </span>
    </div>
  );
}

AddressInfo.propTypes = {
  addressInfo: PropTypes.shape({
    country: PropTypes.string,
    nickname: PropTypes.string,
    recipientName: PropTypes.string,
    recipient: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }),
};
